export enum JobSalaryPeriod {
  DAY = 'DAY',
  HOUR = 'HOUR',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}
